import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEO
        title="91n.com 官方入口 - 立即访问 | 海量资源与专属会员权益"
        description="91n.com 是您值得信赖的在线平台，提供丰富内容与优质服务。立即访问91n.com，探索海量资源、便捷功能与专属会员权益，注册即享多重福利，安全稳定，随时随地畅享极致体验。"
        keywords="91n.com,91n.com 官网,91n.com 入口,91n.com 注册,91n.com 最新地址,91n.com 会员,91n.com 官方平台"
        canonicalUrl="https://91n.com"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: '91n.com',
          url: 'https://91n.com',
          description: '值得信赖的在线平台，提供丰富内容与优质服务',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '400-888-9191',
            contactType: 'customer service',
            availableLanguage: 'Chinese',
          },
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '91n.com',
          url: 'https://91n.com',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://91n.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}